<template>
  <div class="box">
    <a-row align="middle">
      <a-col :span="16">
        <div class="box-left">
          <CommonAlert></CommonAlert>
        </div>
      </a-col>
      <a-col :span="8">
        <div class="box-right">
          <div class="header-actions">
            <Personal title="个人资料"></Personal>
            <button type="button" class="header-action-btn header-action-logout" @click="handleEventLogout">
              <LogoutOutlined />
              <span>退出登录</span>
            </button>
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script setup>
import {ExclamationCircleOutlined, LogoutOutlined} from "@ant-design/icons-vue"
import {createVNode} from "vue"
import {AccessToken, UserInfo} from "@/utils/constant";
import {message, Modal} from "ant-design-vue";
import {useRouter} from "vue-router";
import Personal from "@/components/components_business/user/Personal.vue";
import CommonAlert from "@/components/components_business/header/CommonAlert.vue";
const router = useRouter()

const handleEventLogout = () => {
  Modal.confirm({
    title: '确定要退出系统吗?',
    icon: createVNode(ExclamationCircleOutlined),
    content: "确认退出请点击【确定】，否则请点击【取消】",
    okText: '确定',
    cancelText: '取消',
    onOk() {
      message.success('退出登录')
      localStorage.removeItem(UserInfo);
      localStorage.removeItem(AccessToken);
      router.push({name:'login'})
    },
    onCancel() {},
    class: 'test',
  });
}
</script>

<style scoped>
.box{
  margin: 0;
  padding: 0 20px;
}
.box-left{
  height: 64px;
  line-height: 64px;
}
.box-right{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 64px;
}
.header-actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.header-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  margin: 0;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  background: #fff;
  color: rgba(0, 0, 0, 0.85);
  font-size: 13px;
  line-height: 1;
  cursor: pointer;
  transition: all 0.15s ease;
  user-select: none;
}
.header-action-btn:hover {
  color: #fff;
  background: #1677ff;
  border-color: #1677ff;
}
.header-action-logout {
  color: #cf1322;
  background: #fff2f0;
  border-color: #ffccc7;
}
.header-action-logout:hover {
  color: #fff;
  background: #ff4d4f;
  border-color: #ff4d4f;
}
</style>

<style>
.header-actions .header-action-btn.ant-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  margin: 0;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  background: #fff;
  color: rgba(0, 0, 0, 0.85);
  font-size: 13px;
  line-height: 1;
  box-shadow: none;
}
.header-actions .header-action-btn.ant-btn:hover,
.header-actions .header-action-btn.ant-btn:focus {
  color: #fff !important;
  background: #1677ff !important;
  border-color: #1677ff !important;
}
.header-actions .header-action-btn.ant-btn .anticon {
  font-size: 14px;
}
</style>
